import { useMutation } from '@tanstack/react-query';
import { getRankingComplete } from '../queries/simuladao';

export const useGetRankingComplete = () => {
  const { data, isError, isPending, mutate } = useMutation({
    mutationKey: ['get-simulation-ranking-complete'],
    mutationFn: (slug: string) => getRankingComplete(slug),
    retry: false,
  });

  return {
    data,
    isError,
    isLoading: isPending,
    mutate,
  };
}
